'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Drawer = require('material-ui/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _PropertyHelper = require('../common/PropertyHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	children: _propTypes2.default.node,
	className: _propTypes2.default.string,
	containerClassName: _propTypes2.default.string,
	containerStyle: _propTypes2.default.object,
	disableSwipeToOpen: _propTypes2.default.bool,
	docked: _propTypes2.default.bool,
	onRequestChange: _propTypes2.default.func,
	open: _propTypes2.default.bool,
	openSecondary: _propTypes2.default.bool,
	overlayClassName: _propTypes2.default.string,
	overlayStyle: _propTypes2.default.object,
	style: _propTypes2.default.object,
	swipeAreaWidth: _propTypes2.default.number,
	width: _propTypes2.default.number,
	zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
};

var allowedProperties = Object.keys(propTypes);

var WMDrawer = function WMDrawer(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_Drawer2.default, (0, _PropertyHelper.filter)(props, allowedProperties))
	);
};

exports.default = WMDrawer;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMDrawer/index.js